import axios from 'axios';
import config from '../apiConfig';

/**
 * Returns a promise for a list of all published categories.
 * @param {axios cancellation token} cancelToken - use this to cancel an existing request.
 * Generate this using the helper function getCancellationToken
 * @returns promise
 */
const getAllCategories = cancelToken => {
	const instance = axios.create(config);

	return instance.get('Categories', {
		cancelToken,
	});
};

/**
 * Returns a promise for a list of sub-categories.
 * @param {axios cancellation token} cancelToken - use this to cancel and ongoing request
 * @param	{number} categoryId - category that the subcategories belong to (required)
 * @returns promise
 */
const getSubCategories = (cancelToken, categoryId) => {
	if (!categoryId) {
		throw new Error('Category id is required.');
	}

	// React Router appears to cast our number into string.
	if (Number.isNaN(parseInt(categoryId, 10))) {
		throw new TypeError('Invalid category id.');
	}

	const instance = axios.create(config);

	return instance.get('SubCategories', {
		params: {
			categoryId,
		},
		cancelToken,
	});
};

/**
 * Returns a promise for a list of all published top level categories.
 * These are categories with a parentId of 0.
 * @param {axios cancellation token} cancelToken - use this to cancel an existing request.
 * Generate this using the helper function getCancellationToken
 * @returns promise
 */
const getTopCategories = cancelToken => {
	const instance = axios.create(config);

	return instance.get('TopCategories', {
		cancelToken,
	});
};

export { getAllCategories, getSubCategories, getTopCategories };
